import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import yape from '../../../images/payment/yuno/yape-logo.png';

/**
 * YapeInfoSection component.
 * Renders the information section with Yape logo and features.
 * @param {Object} props - Component props
 * @param {Function} props.t - Translation function
 * @param {boolean} props.isMobile - Whether to render mobile layout
 */
const YapeInfoSection = ({ t, isMobile }) => {
  if (isMobile) {
    return (
      <div className="bg-gray-100 p-5 text-left text-gray-600 rounded-t-xl flex items-center">
        <div className="flex-shrink-0">
          <img src={yape} alt="Yape" className="w-16 h-16" />
        </div>
        <p className="text-sm leading-relaxed opacity-90 max-w-full flex-1 ml-6">
          <Trans
            t={t}
            i18nKey="yape_instructions.first"
            components={{
              strong: <strong />,
            }}
          />
        </p>
      </div>
    );
  }

  return (
    <div className="flex-1 bg-gray-100 p-5 flex flex-col justify-center items-start text-left text-gray-600">
      <div className="flex items-start mb-5 w-full">
        <div className="flex-shrink-0">
          <img src={yape} alt="Yape" className="w-20 h-20 object-contain" />
        </div>
        <p className="text-base leading-tight opacity-90 max-w-[300px] ml-6 mt-0 pt-0 min-h-20 flex items-center">
          <Trans
            t={t}
            i18nKey="yape_instructions.first"
            components={{
              strong: <strong />,
            }}
          />
        </p>
      </div>
      <div className="w-full">
        <div className="flex items-center gap-3 mb-3 text-sm">
          <div className="w-5 h-5 bg-[#c9a1d5] rounded-full flex items-center justify-center">
            <svg className="w-3 h-3" fill="white" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <span>{t('yape.features.no_cost')}</span>
        </div>
        <div className="flex items-center gap-3 mb-3 text-sm">
          <div className="w-5 h-5 bg-[#c9a1d5] rounded-full flex items-center justify-center">
            <svg className="w-3 h-3" fill="white" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <span>{t('yape.features.available_everywhere')}</span>
        </div>
        <div className="flex items-center gap-3 mb-3 text-sm">
          <div className="w-5 h-5 bg-[#c9a1d5] rounded-full flex items-center justify-center">
            <svg className="w-3 h-3" fill="white" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <span>{t('yape.features.immediate_process')}</span>
        </div>
      </div>
    </div>
  );
};

YapeInfoSection.propTypes = {
  t: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default YapeInfoSection;
